import { ITEMS_TYPES } from 'hb-react/shared/apps/Events/constants/itemsTypes';
import { moneyFromCents } from 'hb-react/shared/apps/Memberships/utils/money';
import { CART_ITEM_TYPES } from 'hb-react/shared/components/ShoppingCard/constants/cartConstants';

export const wrapByQuantity = (cartItems) => {
  if (!cartItems) {
    return [];
  }

  const result = cartItems.reduce((acc, value) => {
    const index = acc.findIndex(
      (e) =>
        e.line_itemable_type === value.line_itemable_type &&
        e.line_itemable_id === value.line_itemable_id,
    );

    if (index > -1) {
      const { id, ...elem } = acc[index];

      acc[index] = {
        ...elem,
        quantity: elem.quantity + 1,
      };
    } else {
      const { id, ...elem } = value;

      acc.push({
        ...elem,
        show_one_quantity: elem.line_itemable_type !== CART_ITEM_TYPES.DONATION,
      });
    }

    return acc;
  }, []);

  return result;
};

export const getPromoCodes = (cartItems) =>
  cartItems.filter(
    (item) => item.line_itemable_type === CART_ITEM_TYPES.PROMO_CODE,
  );

export const transformPromoCodes = (
  cartItems,
  currencyCode = 'USD',
  flagEvCurrenciesWithoutCents = false,
) =>
  getPromoCodes(cartItems).map((item) => ({
    ...item,
    price: moneyFromCents(
      item.total_in_cents,
      currencyCode,
      flagEvCurrenciesWithoutCents,
    ).total,
    type: ITEMS_TYPES.PROMO_CODE,
  }));
